import { ASSETS } from "@/data/assets";

// Digital 2ml glass vial with an authentic AlloLabs lab label.
export const Vial = ({ formula, ref: seqRef }) => {
  return (
    <div className="relative flex items-end justify-center select-none" aria-hidden="true">
      <div className="relative" style={{ width: 88, height: 190 }}>
        {/* Cap */}
        <div className="absolute left-1/2 -translate-x-1/2 top-0 z-20 rounded-[3px] vial-cap" style={{ width: 46, height: 20 }} />
        <div className="absolute left-1/2 -translate-x-1/2 top-[18px] z-20 bg-[#2a2a2a] rounded-[2px]" style={{ width: 40, height: 8 }} />
        {/* Neck */}
        <div className="absolute left-1/2 -translate-x-1/2 top-[24px] z-10 bg-white/10 border-x border-white/10" style={{ width: 34, height: 14 }} />
        {/* Body */}
        <div className="absolute left-1/2 -translate-x-1/2 top-[36px] z-0 rounded-b-[14px] rounded-t-[6px] vial-glass overflow-hidden" style={{ width: 72, height: 150 }}>
          {/* liquid */}
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-b from-[#1c1a12] to-[#0c0b07]" style={{ height: 78 }} />
          {/* shine */}
          <div className="absolute top-0 bottom-0 left-[8px] w-[10px] vial-shine opacity-70" />

          {/* Label */}
          <div className="absolute left-1/2 -translate-x-1/2 top-[42px] bg-[#0d0d0d] border border-[var(--al-gold)]/40 rounded-[3px] px-1.5 py-2 flex flex-col items-center gap-1 shadow-lg" style={{ width: 62 }}>
            <img src={ASSETS.logo} alt="" className="h-[14px] w-auto object-contain" />
            <div className="w-full h-[1px] bg-white/10" />
            <span className="font-mono-tech text-[4.5px] leading-none tracking-[0.12em] text-[var(--al-gold)] text-center">
              FOR RESEARCH<br />PURPOSES ONLY
            </span>
            <span className="font-mono-tech text-[5px] leading-tight text-white/80 text-center break-all">
              {formula}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
